import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Select from 'react-select';
import { useGlobalActiveIndicator, useGlobalBivariateIndicator, onSetBivariateIndicator, onSetActiveIndicator, useGlobalActiveGeography } from '../../data/StatusStore';
import Colors from '../utilities/Colors';

interface IndicatorDropdownProps {
  allData: any;
}

const IndicatorDropdown: React.FC<IndicatorDropdownProps> = ({ allData }) => {
  console.log("A021125 allData: ", allData);
  
  const activeIndicator = useGlobalActiveIndicator();
  const activeGeography = useGlobalActiveGeography();
  const bivariateIndicator = useGlobalBivariateIndicator();
  //console.log("I100524 activeIndicator: ", activeIndicator);
  //console.log("I100524 bivariateIndicator: ", bivariateIndicator);
  //console.log("I100524 activeGeography: ", activeGeography);
  console.log("A041425 A --> allData[activeGeography].meta: ", allData[activeGeography].meta);
  const [options, setOptions] = useState<any>(null);
  const [optionsIncrement, setOptionsIncrement] = useState<number>(0);
  const [formattedOptions, setFormattedOptions] = useState<any[]>([]);
  
  //let formattedOptions:any[] = [];


  useEffect(() => {
    console.log("D041425 options", options);
    if (options){
      let _formattedOptions:any[] = [];
      Object.keys(options.DISPLAY_NAME).forEach(key => {
        if (options[activeGeography][key] == "X"){
          //console.log("C012125 key: ", key);
          //console.log("C012125 options.Comparisons[key]", options.Comparisons[key]);
          //console.log("C012125 options['Use note for Comparisons'][key]", options['Use note for Comparisons'][key]);
          if (options.Comparisons[key] == "X" && key !== activeIndicator && key !== bivariateIndicator){
            _formattedOptions.push(
              {
                value: key,
                label: options.DISPLAY_NAME[key],
                category: options["Category 1"][key]
                //label: options['Use note for Comparisons'][key] === "" ? options.DISPLAY_NAME[key] : options['NOTES'][key]
              }
            );
          }
        }
      });
      console.log("D041425 _formattedOptions", _formattedOptions);
      const desiredOrder = ["Core Stats", "Health", "Education", "Work + Wealth", "Safety", "Civics", "Physical World"];
      _formattedOptions.sort((a, b) => {
        const categoryComparison = desiredOrder.indexOf(a.category) - desiredOrder.indexOf(b.category);
        if (categoryComparison !== 0) {
          return categoryComparison;
        }
        return a.label.localeCompare(b.label);
      });

      console.log("D041425 _formattedOptions: ", _formattedOptions);
      const categorizedOptions: any[] = [];
      let currentCategory = '';
      

      _formattedOptions.forEach(option => {
        if (option.category !== currentCategory) {
          currentCategory = option.category;
          categorizedOptions.push({
            value: "unavailable",
            label: currentCategory.toUpperCase(),
            category: currentCategory
          });
        }
        categorizedOptions.push(option);
      });
      setFormattedOptions(categorizedOptions);
      console.log("H020425 categorizedOptions: ", categorizedOptions);
      
      console.log("A021125 formattedOptions: ", formattedOptions);
      console.log("A021125 desiredOrder: ", desiredOrder);
      console.log("A021125 desiredOrder: ", desiredOrder);
      setOptionsIncrement(optionsIncrement + 1);
    }
  }, [options]);

  useEffect(() => {
    console.log("D041425 C --> allData", allData);
    console.log("A041425 C --> activeGeography", activeGeography);
    if (allData && allData[activeGeography] && allData[activeGeography].meta) {
      if (activeGeography === "CD" && allData["PUMA"]?.meta?.DISPLAY_NAME && Object.keys(allData["PUMA"].meta.DISPLAY_NAME).length > 0){
        let _optCD = JSON.parse(JSON.stringify(allData["CD"].meta));
        let _optPUMA =  JSON.parse(JSON.stringify(allData["PUMA"].meta));
        Object.keys(_optPUMA.DISPLAY_NAME).forEach(key => {
          //console.log("D041425 _optCD.DISPLAY_NAME[key]", _optCD.DISPLAY_NAME[key]);
          if (!_optCD.DISPLAY_NAME[key]) {
            _optCD.DISPLAY_NAME[key] = _optPUMA.DISPLAY_NAME[key];
          }
          if (_optCD.Comparisons[key] != "X" && _optPUMA.Comparisons[key] == "X"){
            _optCD.Comparisons[key] = _optPUMA.Comparisons[key];
          }
          if (_optCD.CD[key] != "X" && _optPUMA.PUMA[key] == "X"){
            _optCD.CD[key] = _optPUMA.PUMA[key];
          }
        });
        setOptions(_optCD);
      }else{
        setOptions(allData[activeGeography].meta);
      }
    }
  }, [allData, activeGeography]);

  const handleActiveIndicatorChange = (selectedOption: any) => {
    onSetActiveIndicator(selectedOption.value, "compare", "N/A");
  };

  const handleBivariateIndicatorChange = (selectedOption: any) => {
    onSetBivariateIndicator(selectedOption.value, "compare", "N/A");
  };

  return (
    <div
      style={{
      padding: "20px",
      paddingTop: "10px",
      paddingBottom: "10px",
      }}
    >
      <Select
        key={`${activeGeography}_select_1_${activeIndicator}_${optionsIncrement}`}
        options={formattedOptions}
        defaultValue={{ value: activeIndicator, label: options ? options.DISPLAY_NAME[activeIndicator] : "", category: "" }}
        onChange={handleActiveIndicatorChange}
        placeholder="Select Active Indicator"
        isOptionDisabled={(option) => option.value === 'unavailable'}
        styles={{
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.data.value === 'unavailable' ? Colors.getColorByClass(state.data.category) : Colors.getColorByClass(state.data.category, 1),
            color: state.data.value === 'unavailable' ? '#FFF' : provided.color,
            fontWeight: state.data.value === 'unavailable' ? 'bold' : provided.fontWeight,
            cursor: state.data.value === 'unavailable' ? 'default' : provided.cursor,
          }),
          control: (provided) => ({
            ...provided,
            marginBottom: "10px",
            borderRadius: "16px",
            minHeight: "30px", // Adjusted height
            height: "30px", // Adjusted height
            backgroundColor: Colors.bivariateColorScheme[2][2],
            color: "#FFF", // Set text color to white
            borderColor: Colors.bivariateColorScheme[2][2] + " !important",
            boxShadow: "none !important",
          }),
          valueContainer: (provided) => ({
            ...provided,
            height: "30px", // Align text with adjusted height
            display: "flex",
            alignItems: "center", // Center text vertically
            padding: "0 8px",
            color: "#FFF", // Set text color to white
            fontWeight: "bold", // Set text color to white
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "#FFF", // Ensure selected option text is white
          }),
          input: (provided) => ({
            ...provided,
            margin: "0",
            color: "#FFF", // Set text color to white
          }),
          indicatorSeparator: (provided) => ({
              ...provided,
              backgroundColor: "#fff !important",
              width:'1px',
              marginTop:'4px',
              marginBottom:'4px',
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            height: "30px", // Align chevron with adjusted height
            display: "flex",
            alignItems: "center", // Center chevron vertically
            color: "#FFF", // Set chevron color to white
            svg: {
              fill: "#FFF", // Set SVG chevron color to white
            },
          }),
          menu: (provided) => ({
            ...provided,
            marginTop: "0px",
            marginBottom: "0px",
            width: "calc(100% - 25px)",
            left: "12.5px",
            div:{
              paddingTop:"0px",
              paddingBottom:"0px",
            }
          }),
        }}
      />
      <Select
        key={`${activeGeography}_select_2_${bivariateIndicator}_${optionsIncrement}`}
        options={formattedOptions}
        defaultValue={bivariateIndicator ? { value: bivariateIndicator, label: options ? options.DISPLAY_NAME[bivariateIndicator] : "", category: "" } : null}
        onChange={handleBivariateIndicatorChange}
        placeholder="Select Bivariate Indicator"
        isOptionDisabled={(option) => option.value === 'unavailable'}
        //menuIsOpen={true} // Keep the menu open at all times for development
        styles={{
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.data.value === 'unavailable' ? Colors.getColorByClass(state.data.category) : Colors.getColorByClass(state.data.category, 1),
            color: state.data.value === 'unavailable' ? '#FFF' : provided.color,
            fontWeight: state.data.value === 'unavailable' ? 'bold' : provided.fontWeight,
            cursor: state.data.value === 'unavailable' ? 'default' : provided.cursor,
          }),
          control: (provided) => ({
            ...provided,
            borderRadius: "16px",
            minHeight: "30px", // Adjusted height
            height: "30px", // Adjusted height
            backgroundColor: Colors.bivariateColorScheme[0][0],
            borderColor: Colors.bivariateColorScheme[0][0] + " !important",
            boxShadow: "none !important",
          }),
          valueContainer: (provided) => ({
            ...provided,
            height: "30px", // Align text with adjusted height
            display: "flex",
            alignItems: "center", // Center text vertically
            padding: "0 8px",
            color: "#FFF", // Set text color to white
            fontWeight: "bold", // Set text color to white
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "#FFF", // Ensure selected option text is white
          }),
          input: (provided) => ({
            ...provided,
            margin: "0",
            color: "#FFF", // Set text color to white
          }),
          indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: "#fff !important",
            width:'1px',
            marginTop:'4px',
            marginBottom:'4px',
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            height: "30px", // Align chevron with adjusted height
            display: "flex",
            alignItems: "center", // Center chevron vertically
            color: "#FFF", // Set chevron color to white
            svg: {
              fill: "#FFF", // Set SVG chevron color to white
            },
          }),
          menu: (provided) => ({
            ...provided,
            marginTop: "0px",
            marginBottom: "0px",
            width: "calc(100% - 25px)",
            left: "12.5px",
            div:{
              paddingTop:"0px",
              paddingBottom:"0px",
            }
          }),
        }}
      />
    </div>
  );
};

export default IndicatorDropdown;
